// extracted by mini-css-extract-plugin
export default {"landingCard":"landingCard_landingCard__cOG1q","clickable":"landingCard_clickable__GnxSn"};